import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./smsSlice";

const selectDomain = (state) => state.smsManage || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);
